import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'celularMask',
  standalone: true
})
export class CelularMaskPipe implements PipeTransform {

  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }

    const cleanValue = String(value).replace(/\D/g, '');

    if (cleanValue.length === 13) {
      return cleanValue.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, '+$1 ($2) $3-$4');
    } else if (cleanValue.length === 12) {
      return cleanValue.replace(/(\d{2})(\d{2})(\d{4})(\d{4})/, '+$1 ($2) $3-$4');
    } else if (cleanValue.length === 11) {
      return cleanValue.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (cleanValue.length === 10) {
      return cleanValue.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return cleanValue;
  }
}
